import { Channel, Show, Video } from 'types/api/media';
import { getChannelThumbnailUrl, getShowVerticalUrl } from './cwImageUtils';
import { AppData } from '@lightningjs/sdk';
import { FavoriteChannelItem, WatchlistItem } from 'services/personaService';

export const isWatchlistItem = async (showId: string) => {
  const watchlistItem: WatchlistItem | undefined =
    await AppData!.personaService?.getWatchlistItem(showId);

  return !!watchlistItem;
};

export const getWatchlistLaneItems = async (limit?: number) => {
  let watchlistItems;
  try {
    watchlistItems = await AppData?.personaService?.getWatchlistItems({
      limit,
    });
  } catch (e) {
    console.error(e);
  }
  if (!watchlistItems) return [];

  return watchlistItems.map(item => {
    return buildWatchlistLaneItem(item);
  });
};

export const buildWatchlistLaneItem = (item: WatchlistItem) => {
  const { content_title, content_group_id, content_type, content_release } =
    item;
  const imageUrl = getShowVerticalUrl(content_group_id);
  const laneItem = {
    title: content_title,
    id: content_group_id,
    type: content_type,
    releaseYear: content_release,
    showSlug: content_group_id,
    images: {
      image_vertical: imageUrl,
    },
  };

  return content_type === 'movie'
    ? (laneItem as unknown as Video)
    : (laneItem as unknown as Show);
};

export const getFavoriteChannelLaneItems = async (limit?: number) => {
  let favoriteChannelItems;
  try {
    favoriteChannelItems =
      await AppData?.personaService?.getFavoriteChannelItems(limit);
  } catch (e) {
    console.error(e);
  }

  if (!favoriteChannelItems) return [];

  return favoriteChannelItems.map(item => {
    return buildFavoriteChannelsLaneItem(item);
  });
};

export const buildFavoriteChannelsLaneItem = (item: FavoriteChannelItem) => {
  const { channel_id, content_title, content_type } = item;
  const imageUrl = getChannelThumbnailUrl(channel_id);

  const laneItem = {
    id: channel_id,
    title: content_title,
    type: content_type,
    slug: channel_id,
    contentType: content_type,
    images: {
      homeThumbnail: imageUrl,
    },
  };

  return laneItem as unknown as Channel;
};
